import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function RightBar() {
  const { t } = useTranslation();
  
  // Helper function to get nation class
  const getNationClass = (nationInfo) => {
    if (nationInfo === '1') return 'n1';
    if (nationInfo === '2') return 'n2';
    return '';
  };

  // Helper function to get character class
  const getCharacterClass = (class2) => {
    // Human Mage
    if (['203', '209', '210'].includes(class2)) return 'c13';
    // Human Rogue
    if (['208', '202'].includes(class2)) return 'c12';
    // Human Warrior
    if (['206', '201', '205'].includes(class2)) return 'c11';
    // Human Priest
    if (['211', '212', '204'].includes(class2)) return 'c14';
    // Karus Rogue
    if (['108', '107'].includes(class2)) return 'c22';
    // Karus Warrior
    if (['105', '101', '106'].includes(class2)) return 'c21';
    // Karus Priest
    if (['104', '112', '111'].includes(class2)) return 'c24';
    // Karus Mage
    if (['103', '109', '110'].includes(class2)) return 'c23';
    return '';
  };

  // Example admin data (should come from API/state)
  const adminData = {
    Nation: '1', // or '2'
    Class: '203', // example class
    UserId: 'AdminUser'
  };

  /* global $ */
  useEffect(() => {
    // Tooltipleri aktif et
    if (window.$) {
      $('[data-toggle="tooltip"]').tooltip();
    }
  }, []);

  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1900, settings: { slidesToShow: 4 } },
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
    prevArrow: (
      <button className="slick-prev">
        <i className="icon-left-open-big"></i>
      </button>
    ),
    nextArrow: (
      <button className="slick-next">
        <i className="icon-right-open-big"></i>
      </button>
    ),
  };

  // Statik örnek itemler
  const items = [
    {
      img: "assets/pus-icon/itemicon_3_9928_20_0.png",
      price: "3500",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_5_0807_00_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_3_9928_20_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_5_0807_00_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_3_9928_20_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_5_0807_00_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_3_9928_20_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_5_0807_00_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_3_9928_20_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_5_0807_00_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_3_9928_20_0.png",
      price: "3200",
      cash: "2300",
    },
    {
      img: "assets/pus-icon/itemicon_5_0807_00_0.png",
      price: "3200",
      cash: "2300",
    },
  ];

  return (
    <>
      <div className="col-xs-12 col-sm-12 col-md-3">
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-12">
            <div className="block">
              <div className="registration-button-2">
                <Link to="/register">
                  {t("kayitOl")}
                  <span>{t("sendeBirHesapAc")}</span>
                </Link>
              </div>
            </div>

            <div className="block">
              <div className="download-button">
                <a href="https://www.dosya.tc/server24/mgrzj1/HeraGame.rar.html">
                  {t("oyunuIndir")}
                  <span>{t("sorunsuzOyunIndir")}</span>
                </a>
              </div>
            </div>

            <div className="block">
              <div className="pus-button">
                <Link to="/products">
                  <img src="assets/images/pus.png" alt="" />
                </Link>
              </div>
            </div>

            <div className="block">
              <div className="npoint-button">
                <a
                  rel="noopener noreferrer"
                  href="https://www.klasgame.com/mmorpg-oyunlar/hera-game/hera-game-kc"
                  target="_blank">
                  {t("nPointSatinAl")}
                  <span>{t("resmiSatici")}</span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-12">
            <div className="block">
              <ul className="social">
                <li>
                  <a
                    target="_blank"
                    href="facebook"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Facebook">
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="#!"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Instagram"
                    onClick={(e) => e.preventDefault()}>
                    <i className="fab fa-instagram" aria-hidden="true"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="#!"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Youtube"
                    onClick={(e) => e.preventDefault()}>
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="#!"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Discord"
                    onClick={(e) => e.preventDefault()}>
                    <i className="fab fa-discord"></i>
                  </a>
                </li>

                <li>
                  <a
                    href="#!"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Twitch"
                    onClick={(e) => e.preventDefault()}>
                    <i className="fab fa-twitch" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div className="counter-bar-right">
              <div className="counter-bar">
                <div className="e-logo"></div>
                <div className="bar">
                  <div className="elmorad index" style={{width:"70%"}}>
                    <span></span>
                  </div>
                  <div className="karus" style={{width:"30%"}}>
                    <span></span>
                  </div>
                </div>
                <div className="k-logo"></div>""
              </div>
            </div>
            <div className="counter-bar-right">
              <ul className="server-status">
                <li>
                  {t("oyuncu")}
                  <span> xxx {t("kisi")}</span>
                </li>
                <li>
                  {t("sunucu")}
                  <span className="on/off"> Online/Offline</span>
                </li>
                <li>
                  {t("saat")}
                  <span> xx.xx</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-12">
            <div className="block">
              <div className="header">
                <h3>{t("indirimliurunler")}</h3>
              </div>

              <div className="top-nav-box-carousel">
                <Slider {...sliderSettings}>
                  {items.map((item, index) => (
                    <div className="item" key={index}>
                      <a href="#!" onClick={(e) => e.preventDefault()}>
                        <img src={item.img} alt="" />
                        <span>{item.price}</span>
                        <p>
                          {item.cash} <i>Cash</i>
                        </p>
                      </a>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-md-12">
            <div className="block">
              <div className="header">
                <h3>{t("yoneticiler")}</h3>
              </div>

              <ul className="top-user-list">
                <li>
                  <p>
                    <b className={`nation ${getNationClass(adminData.Nation)}`}></b>{" "}
                    <b className={`class ${getCharacterClass(adminData.Class)}`}></b>{" "}
                  </p>
                  <a href="#!" onClick={(e) => e.preventDefault()}>
                    {adminData.UserId}
                  </a>
                  <span className="status-button on">Online</span>
                  <span className="status-button off">Offline</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default RightBar;
